export default class LunchTicketFilter {
  constructor() {
    this.month = new Date().getMonth() + 1
    this.year = new Date().getFullYear()
    this.employee = null
  }
}
